const styles = {
    mainDataRow: {
        margin: 0,
        padding: 10
    }
  };

  export default styles;



// WEBPACK FOOTER //
// ./src/components/detailsPage/styles/ChartsDataStyles.js